import { tComponentsBlenderNameHard, tComponentsBlenderNameLight, tComponentsBlenderNameMiddle } from '@/Constants/caseComponentsLib/caseComponentsLib';

export type pattern = { distance: number, repeat: number }
//заполнение массивов отверстий по паттерну например [{ distance: 0.1, repeat: 4 },{ distance: 0.3, repeat: 1 }]
//получаем [{ distance: 0.1, repeat: 4 },{ distance: 0.3, repeat: 1 }] где
//distance - расстояние между центрами отверстий
//repeat - количество повторений расстояния distance
//shiftDown-расстояния от низа шкафа до центра 1го отверстия
//для шкафов разделенных полкой по середине:
//middleDownBorder - расстояние от низа шкафа до начала границы посередине
//shiftMiddle - расстояние от middleDownBorder до первого отверстия после middleDownBorder
export const fillArrayHoles = (pattern: Array<pattern>, count: number, arr: number[], shiftDown = 0, shiftMiddle = 0, middleDownBorder?: number) => {
    let i = 0;
    let sum: number = shiftDown;
    let curRepeat = JSON.parse(JSON.stringify(pattern[i].repeat));
    let checkMiddleYet = false;
    arr.push(sum);
    count--;
    while (count--) {
        //для шкафов разделенных по середине
        if (middleDownBorder && middleDownBorder < sum + pattern[i].distance && !checkMiddleYet) {
            sum += shiftMiddle;
            checkMiddleYet = true;
        }
        sum += pattern[i].distance;
        arr.push(sum);

        if (curRepeat-1 === 0) {//repeat === count если паттерн один
            pattern.length-1 > i ? i += 1 : i = 0;
            curRepeat = JSON.parse(JSON.stringify(pattern[i].repeat));
            continue;
        }
        curRepeat--;
    }
};

export const shelveHolesLight: iCaseHolesLight = {
    'tc_1947': [],
    'tc_1995': [],
    'tc_1095': [],
    'tc_1995_2': [],
};
export const wardrobeKitHolesLight: iCaseHolesLight = {
    'tc_1947': [],
    'tc_1995': [],
    'tc_1095': [],
    'tc_1995_2': [],
};
export const driverHolesLight: iCaseHolesLight = {
    'tc_1947': [],
    'tc_1995': [],
    'tc_1095': [],
    'tc_1995_2': [],
};
export const shieldHolesLight: iCaseHolesLight = {
    'tc_1947': [],
    'tc_1995': [],
    'tc_1095': [],
    'tc_1995_2': [],
};
export const CNCHolesLight: iCaseHolesLight = {
    'tc_1947': [],
    'tc_1995': [],
    'tc_1095': [],
    'tc_1995_2': [],
};

export const separatorHolesLight: iCaseHolesLight= {
    'tc_1947': [ 0 ],
    'tc_1995': [ 0 ],
    'tc_1095': [ -0.03487 ],
    'tc_1995_2': [ 0 ],
};

export const shieldHolesMiddle: iCaseHolesMiddle = {
    'amh_tc': [],
    'amh_tc_el': [],
};
export const shelfHolesMiddle: iCaseHolesMiddle = {
    'amh_tc': [],
    'amh_tc_el': [],
};

export const CNCHolesMiddle: iCaseHolesMiddle = {
    'amh_tc': [],
    'amh_tc_el': [],
};
export const driverHolesMiddle: iCaseHolesMiddle = {
    'amh_tc': [],
    'amh_tc_el': [],
};

export const tableHeadHolesHard: iCaseHolesHard1000 = {
    'hard_1000': [ 0 ],
};
export const driver60HolesHard: iCaseHolesHard = {
    'hard_1000': [],
    'hard_2000': [],
};
export const driver125HolesHard: iCaseHolesHard = {
    'hard_1000': [],
    'hard_2000': [],
};

export const driver265HolesHard: iCaseHolesHard = {
    'hard_1000': [],
    'hard_2000': [],
};
export const shelfHolesHard: iCaseHolesHard = {
    'hard_1000': [],
    'hard_2000': [],
};
export const CNCHolesHard: iCaseHolesHard = {
    'hard_1000': [],
    'hard_2000': [],
};

export const shieldHolesHard: iCaseHolesHard = {
    'hard_1000': [],
    'hard_2000': [],
};

export const shieldTc1947: iCaseHolesTC1947 = {
    'tc_1947': [ 0.888 ],
};

export type iCaseHolesLight = { tc_1995: number[]; tc_1995_2: number[]; tc_1947: number[]; tc_1095: number[] }
export type iCaseHolesMiddle =  { amh_tc: number[]; amh_tc_el: number[] };
export type iCaseHolesHard =  { hard_1000: number[]; hard_2000: number[] };
export type iCaseHolesHard1000 =  { hard_1000: number[]};
export type iCaseHolesTC1947 =  { tc_1947: number[]};
//если комплектующее крепиться на попарные отверстия, в массив указываем только нижнее(там где pivot)
//mapTypeToHoles = { blenderNameComponent: { typeToolChest : holes[] } }
export const mapTypeToHoles:    {[ key in tComponentsBlenderNameLight]: iCaseHolesLight|iCaseHolesTC1947} &
                                {[ key in tComponentsBlenderNameMiddle]: iCaseHolesMiddle} &
                                {[ key in tComponentsBlenderNameHard]: iCaseHolesHard|iCaseHolesHard1000}
    = {
    //легкие шкафы
    'shelfS_tcsh_43x47': shelveHolesLight,
    'shelfL_tcsh_95x47': shelveHolesLight,
    'wardrobe_kit_tcsh': wardrobeKitHolesLight,
    'drawerS_tcf_42x45': driverHolesLight,
    'drawerL_tcf_87x45': driverHolesLight,
    'drawer_tcf_39x45': driverHolesLight,
    'tc_shelf_chpu_sk_40': CNCHolesLight,
    'tc_shelf_chpu_sk_50': CNCHolesLight,
    'tc_shelf_chpu_hsk_63': CNCHolesLight,
    'perfo_screen_tcs_50x43': shieldHolesLight,
    'lateral_screen_ms': shieldTc1947,
    'ver_wall_tcd_1800': separatorHolesLight,
    'ver_wall_tcd_1800_2': separatorHolesLight,
    'ver_wall_tcd_900': {
        'tc_1947': [ 0.03487 ],
        'tc_1995': [ 0.03487 ],
        'tc_1095': [ 0 ],
        'tc_1995_2': [ 0.03487 ],
    },
    //средние шкафы
    'perfo_screen_amh_tc': shieldHolesMiddle,
    'shelf_amh_tc': shelfHolesMiddle,
    'shelf_chpu_amh_tc_40': CNCHolesMiddle,
    'shelf_chpu_amh_tc_50': CNCHolesMiddle,
    'shelf_chpu_amh_tc_63': CNCHolesMiddle,
    'drawer_amh_tc_60': driverHolesMiddle,
    'drawer_amh_tc_125': driverHolesMiddle,
    //тяжелые шкафы
    'drawer_hard_60': driver60HolesHard,
    'drawer_hard_125': driver125HolesHard,
    'drawer_hard_265': driver265HolesHard,
    'shelf_hard': shelfHolesHard,
    'sliding_shelf_hard': driver60HolesHard,
    'shelf_chpu_hard_40_s1': CNCHolesHard,
    'shelf_chpu_hard_50_s1': CNCHolesHard,
    'shelf_chpu_hard_63_s1': CNCHolesHard,
    'shelf_chpu_hard_40_s2': CNCHolesHard,
    'shelf_chpu_hard_50_s2': CNCHolesHard,
    'shelf_chpu_hard_63_s2': CNCHolesHard,
    'shelf_chpu_hard_40_s3': CNCHolesHard,
    'shelf_chpu_hard_50_s3': CNCHolesHard,
    'shelf_chpu_hard_63_s3': CNCHolesHard,
    'shelf_chpu_hard': CNCHolesHard,
    'perfo_screen_hard': shieldHolesHard,
    'table_hard_1000': tableHeadHolesHard,

};

//Заполнение массивов
//light
fillArrayHoles([ { distance: 0.025, repeat: 4 }, { distance: 0.045, repeat: 1 } ], 60, shelveHolesLight.tc_1995, 0.135);
shelveHolesLight.tc_1947 = [ ...shelveHolesLight.tc_1995 ];
fillArrayHoles([ { distance: 0.025, repeat: 4 }, { distance: 0.045, repeat: 1 } ], 30, shelveHolesLight.tc_1095, 0.101);
fillArrayHoles([ { distance: 0.025, repeat: 4 }, { distance: 0.045, repeat: 1 } ], 56, shelveHolesLight.tc_1995_2, 0.135, 0.095,0.96);

wardrobeKitHolesLight.tc_1995 = shelveHolesLight.tc_1995.slice(2);
wardrobeKitHolesLight.tc_1947 = shelveHolesLight.tc_1947.slice(2);
wardrobeKitHolesLight.tc_1995 = shelveHolesLight.tc_1095.slice(2);
wardrobeKitHolesLight.tc_1995 = shelveHolesLight.tc_1995_2.slice(2);

fillArrayHoles([ { distance: 0.145, repeat: 12 } ], 12, driverHolesLight.tc_1995, 0.105);
driverHolesLight.tc_1947 = [ ...driverHolesLight.tc_1995 ];
fillArrayHoles([ { distance: 0.145, repeat: 6 } ], 6, driverHolesLight.tc_1095, 0.071);
fillArrayHoles([ { distance: 0.145, repeat: 11 } ], 11, driverHolesLight.tc_1995_2, 0.105, 0.145, 0.975);

fillArrayHoles([ { distance: 0.145, repeat: 11 } ], 11, CNCHolesLight.tc_1995, 0.105);
fillArrayHoles([ { distance: 0.145, repeat: 5 } ], 5, CNCHolesLight.tc_1095, 0.071);
fillArrayHoles([ { distance: 0.145, repeat: 9 } ], 9, CNCHolesLight.tc_1995_2, 0.105, 0.29, 0.83);

fillArrayHoles([ { distance: 0.501, repeat: 3 } ], 3, shieldHolesLight.tc_1995, 0.387);
fillArrayHoles([ { distance: 0.400, repeat: 2 } ], 2, shieldHolesLight.tc_1095, 0.092);
fillArrayHoles([ { distance: 0.501, repeat: 2 } ], 2, shieldHolesLight.tc_1995_2, 0.387, 0.501, 0.837);

//middle
fillArrayHoles([
    { distance: 0.06, repeat: 1 },
    { distance: 0.09, repeat: 1 },
    { distance: 0.03, repeat: 2 },
    { distance: 0.09, repeat: 1 },
    { distance: 0.03, repeat: 2 },
    { distance: 0.09, repeat: 1 },
    { distance: 0.03, repeat: 2 },
    { distance: 0.09, repeat: 1 },
    { distance: 0.03, repeat: 2 },
    { distance: 0.09, repeat: 1 },
    { distance: 0.03, repeat: 2 },
    { distance: 0.09, repeat: 1 },
    { distance: 0.03, repeat: 2 },
], 20, shieldHolesMiddle.amh_tc, 0.597);
shieldHolesMiddle.amh_tc_el = [ ...shieldHolesMiddle.amh_tc ];

fillArrayHoles([ { distance: 0.032, repeat: 47 } ], 47, shelfHolesMiddle.amh_tc, 0.241);
shelfHolesMiddle.amh_tc_el = [ ...shelfHolesMiddle.amh_tc ];

fillArrayHoles([ { distance: 0.025, repeat: 61 } ], 61, CNCHolesMiddle.amh_tc, 0.153);
CNCHolesMiddle.amh_tc_el = [ ...CNCHolesMiddle.amh_tc ];

fillArrayHoles([ { distance: 0.064, repeat: 25 } ], 25, driverHolesMiddle.amh_tc, 0.177);
driverHolesMiddle.amh_tc_el = [ ...driverHolesMiddle.amh_tc ];

//hard
fillArrayHoles([ { distance: 0.025, repeat: 31 } ], 31, shelfHolesHard.hard_1000, 0.125);
fillArrayHoles([ { distance: 0.025, repeat: 71 } ], 71, shelfHolesHard.hard_2000, 0.124);

fillArrayHoles([ { distance: 0.025, repeat: 30 } ], 30, driver60HolesHard.hard_1000, 0.125);
fillArrayHoles([ { distance: 0.025, repeat: 70 } ], 70, driver60HolesHard.hard_2000, 0.124);

fillArrayHoles([ { distance: 0.025, repeat: 27 } ], 27, driver125HolesHard.hard_1000, 0.125);
fillArrayHoles([ { distance: 0.025, repeat: 67 } ], 67, driver125HolesHard.hard_2000, 0.124);

fillArrayHoles([ { distance: 0.025, repeat: 21 } ], 21, driver265HolesHard.hard_1000, 0.125);
fillArrayHoles([ { distance: 0.025, repeat: 61 } ], 61, driver265HolesHard.hard_2000, 0.124);

fillArrayHoles([ { distance: 0.025, repeat: 22 } ], 22, CNCHolesHard.hard_1000, 0.125);
fillArrayHoles([ { distance: 0.025, repeat: 62 } ], 62, CNCHolesHard.hard_2000, 0.124);

fillArrayHoles([ { distance: 0.025, repeat: 26 } ], 26, shieldHolesHard.hard_1000, 0.15);
fillArrayHoles([ { distance: 0.025, repeat: 66 } ], 66, shieldHolesHard.hard_2000, 0.149);
